<template>
  <div>

    <div class="bd-search d-flex align-items-center">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <input v-model="searchText" class="form-control" placeholder="Search Navigation" @keyup="search">
      </div>
      <button class="btn btn-link text-muted d-md-none p-0 ml-3" type="button" @click="isCollapsed = !isCollapsed">
        <i class="fas fa-2x" :class="[ isCollapsed ? 'fa-bars' : 'fa-times' ]" aria-hidden="true"></i>
      </button>
    </div>

    <nav :class="{ 'collapse': isCollapsed}" class="bd-links">
      <div v-for="n of nav" :key="n.root" v-if="!n.isHidden && isVisible(n.pages)" class="bd-toc-item" :class="{ 'active': n.isActive }" @click="isActive(n)">
        <a class="bd-toc-link" href="#">
          {{n.root}}
        </a>
        <ul class="nav bd-sidenav">
          <router-link class="custom-link" exact tag="li" :to="p.url" v-for="p of n.pages" :key="p.name" v-if="!p.isHidden && isAllowed(p.url)">
            <a href="#">
              {{p.name}}
            </a>
            <span v-show="p.name === 'Messages' && messageCount > 0" class="message-badge">{{ messageCount }}</span>
          </router-link>
        </ul>
      </div>

      <div class="bd-toc-item active">
        <ul class="nav bd-sidenav">
          <li>
            <a href="#" @click="logout">
              Logout
            </a>
          </li>
        </ul>
      </div>

    </nav>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'nav-left',
  data() {
    return {
      searchText: '',
      isCollapsed: true,
      messageCount: 0,
      nav: [
        {
          root: 'Home',
          isActive: true,
          pages: [
            { url: '/', name: 'Welcome' },
            { url: '/review-requests', name: 'Review Requests' },
            { url: '/issues', name: 'Issues' },
            { url: '/messages', name: 'Messages', isBadge: true, badgeValue: 0 }
          ]
        },
        {
          root: 'Skunkworks',
          isActive: true,
          pages: [
            { url: '/dashboard', name: 'Dashboard' },
            { url: '/work-orders', name: 'Work Orders' },
            { url: '/dispatch', name: 'Dispatch' }
          ]
        },
        {
          root: 'Administration',
          isActive: true,
          pages: [
            { url: '/admin/config', name: 'Configuration Settings' },
            { url: '/admin/import-data', name: 'Import Data' },
            { url: '/admin/usps/check', name: 'USPS Check Address' },
            { url: '/admin/usps/process', name: 'USPS Process All' },
            { url: '/admin/video', name: 'Video Test' },
            { url: '/admin/teams', name: 'Teams' },
            { url: '/admin/businesses', name: 'Businesses' },
            { url: '/admin/hangfire', name: 'Hangfire' }
          ]
        }
      ]
    }
  },
  async mounted() {
    await this.messageCounts()
  },
  computed: {
    ...mapGetters('auth', ['isAllowed', 'userProfile', 'primaryRole'])
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    ...mapActions('messages', ['getMessageCounts']),
    ...mapActions('workOrders', ['setFilterBy']),
    isActive(nav) {
      return true
      // todo(bwills): if nav is to large we can enable active clicks
      /*
      for (let n of this.nav) {
        n.isActive = false
      }
      nav.isActive = !nav.isActive
      this.$forceUpdate()
      */
    },
    isVisible(pages) {
      return pages.some(p => this.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name
            .toLowerCase()
            .includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    async logout() {
      try {
        if (
          this.primaryRole === 'Tech' ||
          this.primaryRole === 'MasterTech' ||
          this.primaryRole === 'ReviewTech'
        ) {
          await this.setFilterBy({
            filter: 0,
            role: this.primaryRole,
            userId: this.userProfile.id
          })
        }
      } catch (e) {
        console.error(e)
      }
      this.clearToken()
      window.location.assign('/')
    },
    removeSpaces(str) {
      return str.replace(/\s/g, '')
    },
    async messageCounts() {
      let counts = 0
      counts = await this.getMessageCounts({
        username: '',
        workOrderId: '',
        operatorname: this.userProfile.userName
      })
      this.messageCount = counts
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-link {
  position: relative;
}
.message-badge {
  position: absolute;
  left: 90px;
  top: 0px;
  background-color: red;
  color: white;
  border-radius: 50%;
  width: 15px;
  text-align: center;
  font-size: 0.6em;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-left.vue